<template>
  <div>
    <section class="section is-main-section">
      <card-component title="Gateway Form" icon="raspberry-pi" has-back>
        <form @submit.prevent="submit">
          <b-field label="Gateway Info" horizontal>
            <b-input placeholder="Unique Key" v-model="form.key" />
          </b-field>
          <b-field horizontal>
            <b-input placeholder="Serial Number" v-model="form.serial_number" />
          </b-field>
          <b-field horizontal>
            <b-input placeholder="Name" v-model="form.name" />
          </b-field>
          <hr />
          <b-field horizontal>
            <b-button
              type="is-primary"
              :loading="isLoading"
              native-type="submit"
            >
              Submit
            </b-button>
          </b-field>
        </form>
      </card-component>
    </section>
  </div>
</template>

<script>
import { read as readGateway, update as updateGateway } from '@/api/gateway'

export default {
  name: 'UpdateGateway',
  data() {
    return {
      isLoading: false,
      clients: [],
      form: {
        id: null,
        key: null,
        serial_number: null,
        name: null,
      }
    }
  },
  computed: {
    isSuperAdmin() {
      return this.$store.getters['auth/isSuperAdmin']
    },
    isFormValid() {
      // TODO : add validation
      return true
    }
  },
  created() {
    if (this.$route.params.user) {
      const {
        id,
        key,
        serial_number,
        name
      } = this.$route.params.user
      this.form = {
        id,
        key,
        serial_number,
        name
      }
    } else {
      const id = this.$route.params.id
      readGateway(id)
        .then(res => {
          this.form = res.data
        })
    }
  },
  methods: {
    submit() {
      this.isLoading = true

      if (!this.isFormValid) {
        this.isLoading = false
        return
      }

      updateGateway(this.form)
        .then(() => {
          this.$router.back()
        })
        .catch(err => {
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
            queue: false
          })
        })
        .finally(() => { this.isLoading = false })
    }
  }
}
</script>
